import { apiClient } from "lib/apiClient";

export const login = async (): Promise<void> => {
  const response = await apiClient.post(`/sessions`);

  return response.data;
};
